import type { ElplanErrorAlert } from './elplan.alert.types'
import { readElplanDayTableCellFaults } from './elplan.cellFault.helper'
import type { ElplanDayTableCellFault } from './elplan.cellFault.types'
import { resolveElplanErrorAlert } from './elplan.errorAlert.helper'
import { getElplanErrorIdentity } from './elplan.errorBody.helper'
import type { ServerErrorResponse } from './types'

function toServerError(error: unknown): ServerErrorResponse {
  return error instanceof Error ? (error as ServerErrorResponse) : new Error(String(error))
}

export function readElplanDayTableSaveError(error: unknown): {
  cellFaults: ElplanDayTableCellFault[]
  requestAlert: ElplanErrorAlert
  errorCode: string | undefined
} {
  const serverError = toServerError(error)
  const identity = getElplanErrorIdentity(serverError)
  return {
    cellFaults: readElplanDayTableCellFaults(serverError),
    requestAlert: resolveElplanErrorAlert(serverError, {
      operation: undefined,
      fallback: {
        key: 'The table could not be saved: {{message}}',
        values: { message: identity.message ?? serverError.message },
      },
    }),
    errorCode: identity.code,
  }
}
